<template>
    <div class="relative">
        <swiper :options="swiperOptions" ref="slider">
            <swiper-slide v-for="(item, index) in items" :key="index">
                <slot :item="item" :index="index"></slot>
            </swiper-slide>

            <div
                class="swiper-button-prev font-extrabold text-white"
                :class="navClass"
                slot="button-prev"
            ></div>
            <div
                class="swiper-button-next font-extrabold text-white"
                :class="navClass"
                slot="button-next"
            ></div>
        </swiper>
    </div>
</template>

<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";

export default {
    name: "slider",

    components: { Swiper, SwiperSlide },

    props: {
        items: {
            type: Array,
            required: true,
            default: () => []
        },

        options: {
            type: Object,
            required: true,
            default: () => {}
        },

        navClass: {
            type: String
        }
    },

    computed: {
        swiperOptions() {
            return {
                ...this.options,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.swiper-button-prev,
.swiper-button-next {
    width: 50px;
    height: 100%;
    top: 0;
    outline: none;

    &.swiper-button-disabled {
        pointer-events: all;
    }

    &:after {
        position: absolute;
        top: 45%;
    }

    @media (min-width: 640px) {
        width: 25px;
    }
}

.swiper-button-prev {
    left: 0;

    &:after {
        left: 10px;
    }
}
.swiper-button-next {
    right: 0;

    &:after {
        right: 10px;
    }
}
</style>
